import z from "zod";
import { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import { BaseQueryFn } from "@reduxjs/toolkit/query";
import { etlAxiosInstance } from "./etl-axios-instance";
import { getTargetFromSchema, HttpVerb } from "etl/types";

export interface AxiosParams {
	url: string
	method: AxiosRequestConfig["method"]
	data?: AxiosRequestConfig["data"]
	params?: AxiosRequestConfig["params"]
	headers?: AxiosRequestConfig["headers"]
	responseType?: AxiosRequestConfig["responseType"]
};

export const axiosBaseQuery = async <T>(params: AxiosParams): Promise<AxiosResponse<T>> => (
	etlAxiosInstance(params)
);

export const axiosBaseQueryApiSlice = (): BaseQueryFn<AxiosParams & { schema: z.ZodSchema, uuid?: string }> => async (args) => {
	const { method, params, data, responseType, schema, uuid } = args;
	let { headers } = args;

	if (method === HttpVerb.PATCH) {
		headers = {
			...headers,
			"Content-Type": "application/merge-patch+json",
		}
	}

	let { url } = args;

	if (url === undefined && schema) {
		url = getTargetFromSchema(schema);
		if (uuid && url) {
			url = `${url}/${uuid}`;
		}
		url = `${url}?groups=${schema.description}`;
	}

	try {
		const result = await etlAxiosInstance({
			url,
			method,
			data,
			params,
			headers,
			responseType,
		});
		if (result.data?.["hydra:member"]) {
			return {
				data: {
					items: result.data["hydra:member"],
					totalItems: result.data["hydra:totalItems"],
				},
			};
		}
		return { data: result.data };
	} catch (axiosError) {
		const err = axiosError as AxiosError;
		return {
			error: {
				status: err.response?.status,
				data: err.response?.data || err.message,
			},
		};
	}
};
